// @flow
import * as React from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';

import type { FeaturePermission as Feature } from 'common/domain/FeaturePermission';
import { getFeaturePermissions } from '../reducers/FeaturePermissionSelectors';

function featureEnabled(permission: Feature, accessibleFeatures: Feature[]): boolean {
  return accessibleFeatures.includes(permission);
}

type Props = {
  children: Node,
  feature: Feature,
  fallback?: Node,
  accessibleFeatures: Feature[],
};

function FeaturePermission(props: Props) {
  if (!featureEnabled(props.feature, props.accessibleFeatures)) {
    return props.fallback || null;
  }

  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
}

function mapStateToProps(state: Object) {
  return {
    accessibleFeatures: getFeaturePermissions(state),
  };
}

export default connect(mapStateToProps)(withTheme(FeaturePermission));



// WEBPACK FOOTER //
// ./src/common/components/FeaturePermission.js